const SkeletonTrackerList = () => {
  return (
    <>
      {[1, 2, 3, 4, 5, 6, 7, 8]?.map((item) => {
        return (
          <div key={item} className="flex gap-3 w-full">
            <div className="bg-gray-300 h-10 w-10 animate-pulse rounded-full"></div>
            <div className="flex flex-col gap-2">
              <div className="bg-gray-300 h-3.5 w-40 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-32 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-72 animate-pulse rounded-md"></div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SkeletonTrackerList;
